module.exports = __webpack_public_path__ + "img/mapa-regtech-mundo.ec896432.png";